export interface SelectOption {
    value: string;
    label: string;
}

export const professionOptions: SelectOption[] = [
    { value: "technology", label: "Technology" },
    { value: "finance", label: "Finance" },
    { value: "healthcare", label: "Healthcare" },
    { value: "education", label: "Education" },
    { value: "engineering", label: "Engineering" },
    { value: "legal", label: "Legal" },
    { value: "marketing", label: "Marketing" },
    { value: "sales", label: "Sales" },
    { value: "human resources", label: "Human Resources" },
    { value: "arts & entertainment", label: "Arts & Entertainment" },
    { value: "manufacturing", label: "Manufacturing" },
    { value: "retail", label: "Retail" },
    { value: "government", label: "Government" },
    { value: "energy", label: "Energy" },
    { value: "student", label: "Student" },
    { value: "retired", label: "Retired" },
    { value: "other", label: "Other" },
];

export const experienceOptions: SelectOption[] = [
    { value: "junior", label: "Junior" },
    { value: "mid-level", label: "Mid-level" },
    { value: "senior", label: "Senior" },
    { value: "lead", label: "Lead" },
]; 